import { QueryStatus } from '@tanstack/react-query';
import { ReactNode } from 'react';

export interface ListQueryStatusProps {
  status: QueryStatus;
  data: unknown[] | undefined | null;
  infinite?: boolean;
  children: ReactNode;
  pending: ReactNode;
  error: ReactNode;
  empty: ReactNode;
}

export const ListQueryStatus = ({
  status,
  data,
  infinite,
  children,
  empty,
  pending,
  error,
}: ListQueryStatusProps) => {
  if (status === 'pending') {
    return pending;
  }

  if (status === 'error' && !(infinite && data)) {
    return error;
  }

  if (data) {
    if (data.length === 0) {
      return empty;
    }
    return children;
  }

  throw new Error("Shouldn't be here!");
};
